import axios from 'axios';
import type { AnnouncementContent, AnnouncementFormData } from './types';

export const saveAnnouncement = async (
  formData: AnnouncementFormData | AnnouncementContent,
) => {
  await axios.post(`/announcement`, formData);
};
